import * as z from "@-/com.npmjs.zod";

export const morphemeGlyphTileGraphemeMorphemeSliceSchema = z.object({
  additionalPinyin: z.array(z.string()),
  grapheme: z.string(),
  morphemeType: z.literal("grapheme"),
  primaryPinyin: z.string().nullable(),
});

export const morphemeGlyphTileWordMorphemeSliceSchema = z.object({
  additionalPinyin: z.array(z.array(z.string())),
  characters: z.array(
    z.object({
      grapheme: z.string(),
    }),
  ),
  morphemeType: z.literal("word"),
  primaryPinyin: z.array(z.string().nullable()),
});

/** Minimum data to render a morpheme as a front tile button in a grid. */
export const morphemeGlyphTileSliceSchema = z.union([
  morphemeGlyphTileGraphemeMorphemeSliceSchema,
  morphemeGlyphTileWordMorphemeSliceSchema,
]);

export type MorphemeGlyphTileGraphemeMorphemeSlice = z.infer<
  typeof morphemeGlyphTileGraphemeMorphemeSliceSchema
>;
export type MorphemeGlyphTileWordMorphemeSlice = z.infer<
  typeof morphemeGlyphTileWordMorphemeSliceSchema
>;
export type MorphemeGlyphTileSlice = z.infer<typeof morphemeGlyphTileSliceSchema>;
